module.exports = __webpack_public_path__ + "assets/tr.ed6d5f37.svg";